<template>
  <div
    v-if="showSplash"
    style="position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;background:var(--app-splash-bg,#fff);transition:opacity 0.25s ease;"
    :style="{ opacity: splashFading ? 0 : 1 }"
  >
    <CotapLoader :dark="splashDark" :size="56" />
  </div>

  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>

<script setup lang="ts">
const { fetchUser } = useUser()

const showSplash = ref(true)
const splashFading = ref(false)
const splashDark = ref(false)

// Fetch user on app load if session exists
onMounted(async () => {
  try {
    await fetchUser()
  } catch (error) {
    // User not authenticated, this is fine
    console.log('No active session')
  }
})

onMounted(() => {
  splashDark.value = document.documentElement.classList.contains('dark-mode')
  splashFading.value = true
  setTimeout(() => {
    showSplash.value = false
  }, 250)
})
</script>

<style>
:root {
  --app-splash-bg: #fdfcfa;
}
@media (prefers-color-scheme: dark) {
  :root:not(.light-mode) {
    --app-splash-bg: #1a1a1c;
  }
}
:root.dark-mode {
  --app-splash-bg: #1a1a1c;
}
</style>
